<template>
  <div class="settings-wrapper">
    <!--修改绑定手机-->
    <div class="step-list" v-if="developerInfo.phone">
      <div class="step-item" :class="{ active: currentStep === 1 }">
        ① 验证身份
      </div>
      <div class="step-item" :class="{ active: currentStep === 2 }">
        ② 设置新手机
      </div>
      <div class="step-item" :class="{ active: currentStep === 3 }">
        ③ 修改成功
      </div>
    </div>
    <!--暂时屏蔽新增手机号码-->
    <div class="step-list" v-else>
      <div class="step-item" :class="{ active: currentStep === 1 }">
        ① 绑定手机
      </div>
      <div class="step-item" :class="{ active: currentStep === 4 }">
        ② 绑定成功
      </div>
    </div>
    <div class="step-detail">
      <!--修改手机号码-->
      <div v-show="currentStep === 1" class="step1" v-if="developerInfo.phone">
        <div class="phone-wrapper" :model="form">
          <!--修改手机号码-->
          <div class="phone-inner">
            <span class="phone-label">原手机号</span>
            <div class="phone-num disabled">
              <span>{{ form.phone }}</span>
            </div>
          </div>
          <div class="code-inner">
            <input
              v-model="stepForm1.code"
              type="text"
              class="code-inp"
              placeholder="请填写手机验证码"
            />
            <CountDown
              defaultText="获取验证码"
              @click="handleStepOneSendCode('update')"
              class="code-btn"
            ></CountDown>
          </div>
        </div>
        <div class="primary-btn" @click="handleSubmitStep(1)">下一步</div>
      </div>
      <!--新绑定手机号码-->
      <div v-show="currentStep === 1" class="step1" v-else>
        <div class="phone-wrapper" :model="form">
          <div class="phone-inner" >
            <span class="phone-label">手机号</span>
            <van-field  class="phone-num" v-model="form.phone" ></van-field>
          </div>
          <div class="code-inner">
            <input
              v-model="form.code"
              type="text"
              class="code-inp"
              placeholder="请填写手机验证码"
            />
            <CountDown
              defaultText="获取验证码"
              @click="handleStepOneSendCode('add')"
              class="code-btn"
            ></CountDown>
          </div>
        </div>
        <div class="primary-btn" @click="handleSubmitStepBindOne">下一步</div>
      </div>
      <div v-show="currentStep === 2" class="step2" v-if="developerInfo.phone">
        <div class="phone-wrapper">
          <div class="phone-inner">
            <span class="phone-label">新手机号</span>
            <div class="phone-num">
              <input
                v-model="stepForm2.phone"
                type="text"
                class="phone-inp"
                maxlength="11"
                placeholder="请填写手机号码"
              />
            </div>
          </div>
          <div class="code-inner">
            <input
              v-model="stepForm2.code"
              type="text"
              class="code-inp"
              placeholder="请填写手机验证码"
            />
            <CountDown
              defaultText="获取验证码"
              @click="handleStepTwoSendCode"
              class="code-btn"
            ></CountDown>
          </div>
        </div>
        <div class="primary-btn" @click="handleSubmitStep(2)">下一步</div>
      </div>
      <div v-show="currentStep === 3" class="step3">
        <div class="success-inner">
          <van-icon name="passed" class="success-icon"></van-icon>
          <p class="txt">修改成功</p>
        </div>
        <div class="primary-btn" @click="handleSubmitStep(3)">返回</div>
      </div>
      <!--新增号码绑定成功-->
      <div v-show="currentStep===4" class="step3">
        <div class="success-inner" >
          <van-icon name="passed" class="success-icon"></van-icon>
          <p class="txt">绑定成功</p>
        </div>
        <div class="primary-btn" @click="handleSubmitStep(3)">返回</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getVercode, checkVercode, getKfzInfo } from '@/api/common';
import { changePhone } from '@/api/account';
import CountDown from '@/components/CountDown';
import { mapState, mapMutations } from 'vuex';

let ver_id = null;

export default {
  components: {
    CountDown,
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      currentStep: 4,
      isEdit: true,
      stepForm1: {
        code: '',
      },
      stepForm2: {
        phone: '',
        code: '',
      },
      form: {},
    };
  },
  computed: {
    ...mapState(['developerInfo', 'userInfo']),
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.firstBindPhone == 1) {
      to.meta.title = '绑定手机';
    }
    next && next();
  },
  methods: {
    ...mapMutations(['SET_DEVELOPER_INFO']),
    init() {
      this.currentStep = 1;
      this.resetAllForm();
      //判断是否为新增手机号码
      if (this.developerInfo.phone) {
        this.form = {
          phone: this.developerInfo.phone,
          code: '',
        };
      } else {
        this.form = {
          phone: '',
          code: '',
        };
        this.$router.meta.title = '绑定手机号码';
      }
    },
    // 第一步 - 获取验证码
    async handleStepOneSendCode(type) {
      if (!this.form.phone) {
        return this.$toast.fail('请输入手机号码');
      }
      await getVercode({
        //  phone: this.developerInfo.phone,
        phone: this.form.phone,
        tk: this.userInfo.tk,
        op: type === 'add' ? 1 : 2
      });
      this.$toast.success('验证码已发送至您的手机');
    },
    // 第二步 - 获取验证码
    async handleStepTwoSendCode(callback) {
      if (!this.stepForm2.phone) {
        return this.$toast.fail('请输入手机号码');
      }

      await getVercode({ phone: this.stepForm2.phone, tk: this.userInfo.tk, op: 3 });
      this.$toast.success('验证码已发送至您的手机');

      typeof callback === 'function' && callback();
    },
    // 下一步
    handleSubmitStep(step) {
      switch (step) {
        case 1:
          this.handleSubmitStepOne();
          break;
        case 2:
          this.handleSubmitStepTwo();
          break;
        case 3:
          this.handleSubmitStepThree();
          break;
        default:
          break;
      }
    },
    // 提交 - 第一步
    async handleSubmitStepOne() {
      const { code } = this.stepForm1;
      if (!code) {
        return this.$toast.fail('请输入手机验证码');
      }

      // 发送请求
      this.$toast.loading('请稍候...');
      let res = await checkVercode({ vercode: code, op: 2 });
      ver_id = res.ver_id;
      this.$toast.success('操作成功');
      this.$toast.clear();
      this.currentStep = 2;
    },
    //第一步绑定手机号码（新增）
    async handleSubmitStepBindOne() {
      //const { code } = this.stepForm1;

      if (!this.form.code) {
        return this.$toast.fail('请输入手机验证码');
      }

      // 发送请求
      this.$toast.loading('请稍候...');
      //  await checkVercode({ vercode: code });
      await changePhone({
        vercode: this.form.code,
        new_phone: this.form.phone,
        tk: this.userInfo.tk,
        op: 1,
      });
      this.$toast.success('操作成功');
      this.$toast.clear();
      this.currentStep = 4;
      this.fetchKfzInfo();
    },

    // 提交 - 第二步
    async handleSubmitStepTwo() {
      const { phone, code } = this.stepForm2;
      if (!phone) {
        return this.$toast.fail('请输入手机号码');
      }
      if (!code) {
        return this.$toast.fail('请输入手机验证码');
      }

      // 发送请求
      this.$toast.loading('请稍候...');
      await changePhone({
        vercode: code,
        new_phone: phone,
        old_phone: this.developerInfo.phone,
        tk: this.userInfo.tk,
        ver_id: ver_id,
        op: 3,
      });
      this.$toast.success('操作成功');
      this.$toast.clear();
      this.currentStep = 3;

      // 获取新手机号
      this.fetchKfzInfo();
    },
    // 第三步
    handleSubmitStepThree() {
      this.$router.push('/account/settings');
    },
    // 存储新手机号
    async fetchKfzInfo() {
      const res = await getKfzInfo();
      this.SET_DEVELOPER_INFO(res.data);
    },
    // 重置表单
    resetAllForm() {
      this.stepForm1 = { code: '' };
      this.stepForm2 = { phone: '', code: '' };
    },
  },
};
</script>

<style lang="less" scoped>
.settings-wrapper {
  min-height: 80vh;
  padding: 80px;
  background-color: #fff;
}
.step-list {
  position: relative;
  display: flex;
  justify-content: space-between;

  &::before {
    content: '';

    position: absolute;
    top: 49%;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: #d9d9d9;
  }

  .step-item {
    position: relative;
    padding: 0 16px;
    background-color: #fff;
    color: #8c8c8c;

    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
    }
    &.active {
      color: @primaryColor;
    }
  }
}
.phone-wrapper {
  padding-top: 45px;
}
.phone-inner {
  display: flex;
  height: 54px;

  border: 1px solid #d9d9d9;
  border-radius: 4px;
  line-height: 54px;
  color: #8c8c8c;

  .phone-label {
    padding: 0 16px;
    border-right: 1px solid #d9d9d9;
    background-color: #f5f5f5;
  }
  .phone-num {
    flex: 1;
    padding: 0 16px;

    &.disabled {
      background-color: #f5f5f5;
    }
  }
  .phone-inp {
    width: 100%;
    height: 100%;
    padding: 0;
    background-color: transparent;
  }
}
.code-inner {
  margin-top: 36px;
  height: 56px;
  display: flex;
  justify-content: space-between;

  .code-inp {
    flex: 1;

    width: 1%;
    height: 56px;
    padding: 0 15px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
  }
  .code-btn {
    flex-shrink: 0;
    height: 56px;
    margin-left: 30px;
    font-size: 24px;
  }
}
.success-inner {
  padding-top: 100px;
  text-align: center;
  .success-icon {
    font-size: 100px;
    color: @primaryColor;
  }
  .txt {
    padding-top: 30px;
    font-size: 32px;
  }
}

.primary-btn {
  height: 70px;
  margin-top: 70px;
  line-height: 70px;
  background: #fd9b21;
  border-radius: 8px;
  text-align: center;
  font-size: 28px;
  color: #fff;
}
</style>
